import { apiClient } from "lib/apiClient";
import {
  ICoordinate,
  IStandardGeographyDto,
  StandardGeographyTypeEnum,
} from "features/MarketAreas/types";

export interface IResolveStandardGeographyPayload {
  type: StandardGeographyTypeEnum;
  coordinate: ICoordinate;
}

export const resolveStandardGeography = async (
  payload: IResolveStandardGeographyPayload,
  signal?: AbortSignal
): Promise<IStandardGeographyDto> => {
  const response = await apiClient.post<IStandardGeographyDto>(
    "/market-areas/helper/coordinates/resolve",
    payload,
    { signal }
  );

  return response.data;
};
